import { COLOR_PALETTE } from 'constants/ui';

export const CHART_TITLE = 'Loan(s) To Value';

export const CHART_HEIGHT = 16;

export const CHART_COLORS = {
  RED: COLOR_PALETTE.RED[6],
  DARK_RED: COLOR_PALETTE.RED[8],
  ORANGE: COLOR_PALETTE.ORANGE[6],
  YELLOW: COLOR_PALETTE.ORANGE[4],
  GREEN: COLOR_PALETTE.GREEN[6],
  BLUE: COLOR_PALETTE.BLUE[7],
};

export const ADDITIONAL_LOAN_NAME = 'Additional Loan(s)';

export const LTV_LIMIT = {
  PERCENT: 0.33,
  WIDTH: 220,
};
